// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"EH-z","smallCardRow":"FH-z","largeCardRow":"GH-z","productSearchRow":"HH-z","curatedRow":"IH-z"};